(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-login"]) return;
  try {
    
    const $forgot_ctn = document.querySelector('.create-forg')
    document.querySelector('.create-forg__forgot').addEventListener('click', () => {
        $forgot_ctn.classList.toggle('is-forgot')
    })
    
    const $field_pw = document.querySelector('.field-password')
    const $toggle_pw = document.querySelector('.toggle-pw')
    const $input_pw = document.querySelector('#Password')

    $toggle_pw.addEventListener('click', () => {
        $field_pw.classList.toggle('show-pw')
        if($field_pw.classList.contains('show-pw')) {
            $input_pw.setAttribute("type", 'text');
        } else {
            $input_pw.setAttribute("type", 'password');
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
    const $field_pw = document.querySelector('.field-password')
    const $toggle_pw = document.querySelector('.toggle-pw')
    const $input_pw = document.querySelector('#Password')

    $toggle_pw.addEventListener('click', () => {
        $field_pw.classList.toggle('show-pw')
        if($field_pw.classList.contains('show-pw')) {
            $input_pw.setAttribute("type", 'text');
        } else {
            $input_pw.setAttribute("type", 'password');
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
    const $forgot_ctn = document.querySelector('.create-forg')
    document.querySelector('.create-forg__forgot').addEventListener('click', () => {
        $forgot_ctn.classList.toggle('is-forgot')
    })
    
    const $field_pw = document.querySelector('.field-password')
    const $toggle_pw = document.querySelector('.toggle-pw')
    const $input_pw = document.querySelector('#Password')

    $toggle_pw.addEventListener('click', () => {
        $field_pw.classList.toggle('show-pw')
        if($field_pw.classList.contains('show-pw')) {
            $input_pw.setAttribute("type", 'text');
        } else {
            $input_pw.setAttribute("type", 'password');
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	const handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;

		observer.unobserve(productRecommendationsSection);

		const url = productRecommendationsSection.dataset.url;

		fetch(url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('.product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					productRecommendationsSection.innerHTML = recommendations.innerHTML;
				}
			})
			.catch(e => {
				console.error(e);
			});
	};

	const productRecommendationsSection = document.querySelector('.product-recommendations');
	const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

	observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
